import type { ScenarioPromptsBlock, SourceLanguageCode } from '@ellie/shared';
import { BlockHeader } from '../BlockHeader';
import { NativeHint } from '../NativeHint';

interface Props {
  block: ScenarioPromptsBlock;
  index: number;
  nativeLanguage: SourceLanguageCode;
  targetLanguage: string;
  pageNumber: number;
}

export function ScenarioPromptsPreview({
  block,
  index,
  nativeLanguage,
  targetLanguage,
  pageNumber,
}: Props) {
  return (
    <div className="wb-page">
      <BlockHeader block={block} index={index} />

      <div className="wb-block-instructions">
        <span className="wb-icon">{'\u{1F4AD}'}</span>
        <div>
          <p>{block.instructions}</p>
          <NativeHint
            text={block.instructionsNative}
            nativeLanguage={nativeLanguage}
            label={targetLanguage.toUpperCase()}
          />
        </div>
      </div>

      <div className="wb-scenarios">
        {block.scenarios.map((scenario, i) => (
          <div key={i} className="wb-scenario-card">
            <div className="wb-scenario-header">
              <span className="wb-scenario-emoji">{scenario.emoji || '\u{1F4AC}'}</span>
              <div>
                <p className="wb-scenario-situation">
                  {scenario.situation}
                  <span className="wb-target-lang">{scenario.situationTarget}</span>
                </p>
              </div>
            </div>

            {scenario.helpfulVocabulary.length > 0 && (
              <div className="wb-scenario-vocab">
                <span className="wb-scenario-vocab-label">Helpful vocabulary</span>
                {scenario.helpfulVocabulary.map((word, j) => (
                  <span key={j} className="wb-scenario-vocab-word">
                    {word}
                  </span>
                ))}
              </div>
            )}

            <div className="wb-scenario-write">
              <div className="wb-scenario-write-label">{'\u{270F}\u{FE0F}'} Your answer</div>
              <div className="wb-scenario-write-lines">
                <div className="wb-scenario-write-line" />
                <div className="wb-scenario-write-line" />
                <div className="wb-scenario-write-line" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <span className="wb-page-number">{pageNumber}</span>
    </div>
  );
}
